import { syncBuffersFor } from "./bufferUtils";

export const firstDrawPolygonLayerId = (map) => {
  const layers = map.getStyle()?.layers || [];
  const l = layers.find(x => x?.id?.startsWith('gl-draw-polygon'));
  return l?.id || null;
};

export const ensureDrawAboveLine = (map) => {
  const beforeId = firstDrawPolygonLayerId(map);
  if (!beforeId) return;
  if (map.getLayer('line')) map.moveLayer('line', beforeId);
  if (map.getLayer('line-outline')) map.moveLayer('line-outline', beforeId);
};

export const handleDrawPoint = (setDrawMode) => () => {
  setDrawMode(prev => ({
    ...prev,
    point: 'simple_select',
  }));
};

export const handleDrawBuffer = (map, setDrawMode, bufferDistances, setPolygon, setExpanded) => (e) => {
  if (!bufferDistances.length || !setPolygon) return;

  e.features.forEach((poly) => {
    poly.properties = {
      ...(poly.properties || {}),
      assetContour: true,
    };
    setPolygon(poly);
    syncBuffersFor(poly, map, bufferDistances);
  });

  setDrawMode(prev => ({ ...prev, home: 'simple_select' }));
  setExpanded(true);
};